import Vue__default, { ref } from "vue";
import Message from "./Message.vue.mjs";
import useZIndex from "../../../../hooks/useZIndex.mjs";
const activeMessages = [];
const createInstance = async ({
  type,
  message,
  duration = 3e3
}) => {
  const container = document.createElement("div");
  container.setAttribute("class", "t-message-container");
  const fullscreenElement = document.fullscreenElement || document.body;
  fullscreenElement.appendChild(container);
  const uniqueKey = `message-${Date.now()}-${Math.random()}`;
  const updateTopValues = () => {
    activeMessages.forEach((msg, index) => {
      msg.updateTop(`calc(6% + ${index * 6}%)`);
    });
  };
  const removeMessage = (msg) => {
    const index = activeMessages.indexOf(msg);
    if (index !== -1) {
      activeMessages.splice(index, 1);
      updateTopValues();
    }
  };
  const onRemove = () => {
    vm.$destroy();
    fullscreenElement.removeChild(container);
    removeMessage(messageInstance);
  };
  const topValue = ref(`calc(6% + ${activeMessages.length * 6}%)`);
  const messageInstance = {
    key: uniqueKey,
    updateTop: (newTop) => {
      topValue.value = newTop;
    }
  };
  activeMessages.push(messageInstance);
  const zIndex = useZIndex().nextZIndex();
  const messageConstruct = Vue__default.extend({
    render: (h) => h(Message, {
      key: uniqueKey,
      props: {
        type,
        message,
        duration,
        remove: onRemove,
        top: topValue,
        zIndex
      }
    })
  });
  const vm = new messageConstruct({
    el: document.createElement("div")
  }).$mount();
  container.appendChild(vm.$el);
};
export {
  createInstance as default
};
